import React from 'react';
import { AmountPriceContainer } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice';
// import AmountPriceContainer from '@configuratorware/configurator-frontendgui/App/Shared/Containers/AmountPrice';
import CustomAmountPriceContainer from '../../../Shared/Containers/AmountPrice';

export default (props) => (
  <CustomAmountPriceContainer
    {...props}
  />
);
